import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import ProjectPolicyConflictsPageContentQueryNode, {
	type ProjectPolicyConflictsPageContentQuery,
} from './__generated__/ProjectPolicyConflictsPageContentQuery.graphql.ts';
import type {
	ProjectPolicyConflictsPageExtraProps,
	RemediationProduct,
} from './ProjectPolicyConflictsPage.entrypoint.types.tsx';

type ProjectPolicyConflictsPageResolverEntryPointComponent = EntryPointComponent<
	{ projectPolicyConflictsPage: ProjectPolicyConflictsPageContentQuery },
	{},
	{},
	ProjectPolicyConflictsPageExtraProps
>;

export const createProjectPolicyConflictsPageResolverEntryPoint = (
	product: RemediationProduct,
): EntryPoint<ProjectPolicyConflictsPageResolverEntryPointComponent, EntryPointRouteParams> =>
	createEntryPoint({
		root: JSResourceForUserVisible<ProjectPolicyConflictsPageResolverEntryPointComponent>(
			/* webpackChunkName: "async-guided-autonomy-remediation-project" */ './ProjectPolicyConflictsPage.tsx',
			{ entryFsSsrLiftImportToModule: true },
		),
		getPreloadProps: ({ context: { match, query }, tenantContext }: EntryPointRouteParams) => {
			const projectKey = match.params.projectKey ?? '';

			return {
				queries: {
					projectPolicyConflictsPage: {
						parameters: ProjectPolicyConflictsPageContentQueryNode,
						variables: {
							cloudId: tenantContext.cloudId,
							projectKey,
						},
						options: {
							fetchPolicy: 'store-or-network' as const,
						},
					},
				},
				extraProps: {
					product,
					projectKey: projectKey || undefined,
					entityType: match.params.entityType ?? undefined,
					sourceEntityId: query.sourceEntityId || undefined,
				},
			};
		},
	});
